import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import { ToolbarText } from '@kerfjs/ui/toolbar-text';
import type { WorkbenchPanelToggle, WorkbenchPanelToolbar } from '@kerfjs/ui/workbench';
import type { SafeHtml } from 'kerfjs';

/** The assistant rail's standard Workbench toggle (HS2-AC9K4G). */
export const ASSISTANT_TOGGLE: WorkbenchPanelToggle = {
  action: 'toggle-inspector',
  name: 'Assistant',
  hideLabel: 'Collapse Assistant',
};

/**
 * The assistant rail's Workbench panel toolbar: its title, the conversation
 * actions, and the standard toggle, which Kerf moves to the work area's
 * toolbar while the rail is collapsed (HS2-AC9K4G).
 */
export function assistantToolbar({
  label = 'AI Assistant',
  title = 'AI Assistant',
  scopeActions,
}: {
  label?: string;
  title?: string | null;
  scopeActions?: SafeHtml;
} = {}): WorkbenchPanelToolbar {
  return {
    label,
    title: title === null ? undefined : <ToolbarText text={title} />,
    leading:
      scopeActions === undefined ? undefined : (
        <ToolbarControlGroup label="Conversation Actions" appearance="borderless">
          {scopeActions}
        </ToolbarControlGroup>
      ),
    toggle: ASSISTANT_TOGGLE,
  };
}
